import '.a{display:flex;}.ssr-plugin'
import '.s{flex-direction:row;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.bv{height:100vh;}.ssr-plugin'
import '.ax{flex-grow:1;}.ssr-plugin'
import '.aa{min-width:0px;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.fa{margin-top:2rem;}.ssr-plugin'
import '.d0{min-height:0px;}.ssr-plugin'
import '.c0{overflow-y:auto;}.ssr-plugin'
import '.fo{max-width:60rem;}.ssr-plugin'
import '.fp{margin-left:auto;}.ssr-plugin'
import '.fq{margin-right:auto;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { InitiativeSideBar } from '@app/components/blocks/sidebar/InitiativeSideBar'
import { ClientOnly } from '@based/sdk/react'
import Column from '@app/components/layout/Column'

export const InitiativeViewPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <Column alignItems="stretch">
        <div className="a s v bv"
          style={{
            padding: isMobile ? '0rem' : '1.5rem',
            gap: isMobile ? 0 : '5rem',}}
        >
          <InitiativeSideBar />
          <div className="ax aa a b"
          >
            <DashboardNavBar
              initiativeDashboard={true}
              style={{ backgroundColor: 'var(--palette-white)' }}
            />
            <div className="n a b fa ax d0 c0 fo fp fq"
              style={{
                gap: gap,
                paddingInline: isMobile ? '1rem' : 0,}}
            >
              {children}
            </div>
          </div>
        </div>
      </Column>
    </ClientOnly>
  )
}
